import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IRecipient } from '@ebb-v2/ebb-integration';

import { Apollo } from 'apollo-angular';
import { SaveRecipientMutation } from '@ebb-v2/ebb-integration';

@Injectable({
    providedIn: 'root'
  })

export class RecipientApiService  {
  
  constructor(
    private apollo: Apollo
  ) { }

  public SaveRecipient(recipientId: string, recipientInput: IRecipient,applicationId: string) : Observable<IRecipient> {
    return this.apollo
      .mutate({
        mutation: SaveRecipientMutation,
        variables : {
            recipientId,
            recipientInput,
            applicationId
        }
      })
      .pipe(map(result => result.data['saveRecipient'] as IRecipient));
  }

}